<div data-cy="chat-channel-sidebar__page">
    <div class="d-flex align-items-center justify-content-between gap-6 ml-10 py-22 px-12">
        <i class="uil uil-chat unicon-icon d-text-middle"></i>
        <h2 class="d-text-bold d-text-uppercase">{{ 'chat_sidebar.title' | transloco }}</h2>
    </div>

    <div *ngIf="isLoading()">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <ng-container *ngIf="!isLoading()">
        <div class="srch-li" #searchSubproject *ngIf="this.globals.subprojects.length">
            <div class="search-box-container">
                <i class="uil uil-search uil-icon"></i>
                <input data-cy="chat-channel-sidebar__search-box-input" class="search-box" placeholder="{{'text.search_in_subprojects' | transloco}}" [value]="searchTerm" (keyup)="onSearchInput($event)">
                <div class="icons-box">
                    <!-- <i class="uil uil-bell uil-icon"></i>
                    <i class="uil uil-direction uil-icon"></i> -->
                </div>
            </div>

        </div>

        <!-- Tree View -->
        <div class="tree-list">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="width: 100%;">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node">
                    <span class="top-lvl">
                        <div *ngIf="node?.is_first_shared && (node?.shared_level==='chat' || node?.shared_level==='read') && node?.status==='accepted'" class="external-heading">
                            Extern gedeelde projecten
                        </div>
                        <mat-divider [class.t-mrg]="treeControl.getLevel(node) == 0"></mat-divider>
                        <div class="node-wrapper">
                            <div class="node p-node"
                                [style]="{'padding-left': treeControl.getLevel(node) * 21 + 'px !important'}">
                                <span data-cy="chat-channel-sidebar__open-chat-panel" class="node pointer" (click)="openChatPanel(node)">
                                    <span class="node-wrapper" style="position: relative;">
                                        <div class="vertical-line dots-position" *ngIf="treeControl.getLevel(node) > 0">
                                        </div>
                                        <div class="vertical-line dots-position ml-dots"
                                            *ngIf="(treeControl.getLevel(node) == 3 && !isChildOfLastSibling(node)) || (treeControl.getLevel(node) == 4 && !isGrandparentLastSibling(node))"
                                            [style.left]="treeControl.getLevel(node) ==3 ? '-17px !important' : '-38px !important'">
                                        </div>
                                        <div class="vertical-line dots-position ml-dots"
                                            *ngIf="treeControl.getLevel(node) == 4 && !isChildOfLastSibling(node)">
                                        </div>
                                        <div class="vertical-line dots-position left-dots-lvl-gt1"
                                            *ngIf="( treeControl.getLevel(node) == 4 && !isGreatGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 3 && !isGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 2 && !isChildOfLastSibling(node))"
                                            [style.left]="treeControl.getLevel(node) ==2 ? '-17px !important' : treeControl.getLevel(node) == 3 ? '-38px !important':'-59px !important'">
                                        </div>
                                        <div class="vertical-line dots-position bottom-below-half-dots"
                                            *ngIf="treeControl.getLevel(node) > 0 && !isLastSibling(node)"></div>
                                        <div class="horizontal-line" *ngIf="treeControl.getLevel(node) > 0"></div>
                                        <ngx-avatars [style]="AvatarCustomStyle" [name]="node.name" initialsSize="2"
                                            size="30" [borderColor]="node.color" fgColor="#000000" bgColor="#FFFFFF">
                                        </ngx-avatars>
                                    </span>
                                    <!-- use a disabled button to provide padding for tree leaf -->
                                    <span class="fs-13 flex align-center">
                                        <span>{{node.name}}</span>
                                        <span class="chat-notification-badge" *ngIf="node.notificationCount > 0">{{node.notificationCount}}</span>
                                    </span>
                                </span>
                                <span class="node">
                                    <mat-icon class="mat-icon-rtl-mirror pointer" matTreeNodeToggle
                                        [attr.aria-label]="'Toggle ' + node.name" style="visibility: hidden;">
                                        {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                                    </mat-icon>
                                </span>
                            </div>
                        </div>
                    </span>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node *matTreeNodeDef="let node;when: hasChild">
                    <span class="top-lvl">
                        <mat-divider [class.t-mrg]="treeControl.getLevel(node) == 0"></mat-divider>
                        <div class="node-wrapper">
                            <div class="node p-node"
                                [style]="{'padding-left': treeControl.getLevel(node) * 21 + 'px !important'}">
                                <span data-cy="chat-channel-sidebar__open-chat-panel-2" class="node pointer" (click)="openChatPanel(node)">
                                    <span class="node-wrapper" style="position: relative;">
                                        <div class="vertical-line dots-position" *ngIf="treeControl.getLevel(node) > 0">
                                        </div>
                                        <div class="vertical-line dots-position ml-dots"
                                            *ngIf="(treeControl.getLevel(node) == 3 && !isChildOfLastSibling(node)) || (treeControl.getLevel(node) == 4 && !isGrandparentLastSibling(node))"
                                            [style.left]="treeControl.getLevel(node) ==3 ? '-17px !important' : '-38px !important'">
                                        </div>
                                        <div class="vertical-line dots-position ml-dots"
                                            *ngIf="treeControl.getLevel(node) == 4"></div>
                                        <div class="vertical-line dots-position left-dots-lvl-gt1"
                                            *ngIf="( treeControl.getLevel(node) == 4 && !isGreatGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 3 && !isGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 2 && !isChildOfLastSibling(node))"
                                            [style.left]="treeControl.getLevel(node) ==2 ? '-17px !important' : treeControl.getLevel(node) == 3 ? '-38px !important':'-59px !important'">
                                        </div>
                                        <div class="vertical-line dots-position bottom-below-half-dots"
                                            *ngIf="treeControl.getLevel(node) > 0 && !isLastSibling(node)"></div>
                                        <div class="vertical-line dots-position mid-dots"
                                            [class.mid-dots-lvl1]="treeControl.getLevel(node) == 0"
                                            *ngIf="treeControl.isExpanded(node)"></div>
                                        <div class="horizontal-line" *ngIf="treeControl.getLevel(node) > 0"></div>
                                        <ngx-avatars [style]="AvatarCustomStyle" [name]="node.name" initialsSize="2"
                                            size="30" [borderColor]="node.color" fgColor="#000000" bgColor="#FFFFFF">
                                        </ngx-avatars>
                                    </span>
                                    <span class="fs-13 flex align-center">
                                        <span>{{node.name}}</span>
                                        <span class="chat-notification-badge" *ngIf="node.notificationCount > 0">{{node.notificationCount}}</span>
                                    </span>
                                </span>
                                <span class="node">
                                    <mat-icon class="mat-icon-rtl-mirror pointer" matTreeNodeToggle
                                        [attr.aria-label]="'Toggle ' + node.name">
                                        {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                                    </mat-icon>
                                </span>
                            </div>
                        </div>
                    </span>
                </mat-tree-node>
            </mat-tree>
            <mat-divider [style.margin-top]="'12px !important'"></mat-divider>
        </div>
    </ng-container>
</div>